import request from "../utils/fetch";

export function getProductList(data) {
  return request({
    url: "/company/company/product/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function getOrderList(data) {
  return request({
    url: "/company/company/get/order/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function getPaidGoodsVoucher(params) {
  return request({
    url: `/company/company/paid/get/voucher`,
    method: "get",
    requestBody: "query",
    loading: true,
    params: params,
  });
}

// 上传头像
export function uploadHeader(data) {
  return request({
    url: "/public/file/upload?folder=PC",
    method: "post",
    requestBody: "upload",
    loading: true,
    data: data,
  });
}

export function getAddOrder(data) {
  return request({
    url: "/company/company/add/order",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function exportGoods(data) {
  return request({
    url: `/company/company/export`,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    responseType: 'blob', // 设置响应类型为blob
  });
}